// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__3kTf4","icon":"style_icon__ot2cx","badge":"style_badge__UlUgo"};